import styled from "styled-components";

const AsonicTableLayout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export default AsonicTableLayout;
